import PropTypes from "prop-types";
import React, { useState } from "react";
import Grid from "@mui/material/Unstable_Grid2";
import { Box } from "@mui/material";
import { BisListingMapped } from "../bisListingMapped/BisListingMapped";
import { BisListingNotMapped } from "../bisListingNotMapped/BisListingNotMapped";
import { initLocalization } from "../../../utils/helpers";
import { globalStrings } from "../../../global.locale";

export const AllmappingsCreation = ({ selectedMedia }) => {
  initLocalization(globalStrings);
  const [refreshKey, setRefreshKey] = useState(0);

  const handleRefreshBothSides = () => {
    setRefreshKey((prev) => prev + 1);
  };

  return (
    <Box
      sx={{
        height: "100vh",
        overflowY: "auto",
        overflowX: "hidden",
      }}
    >
      <Grid
        container
        direction="column"
        flexWrap="nowrap"
        sx={{
          height: "100%",
          overflowY: "auto",
          overflowX: "hidden",
        }}
        className="all-mappings-creation"
        py={6}
        px={{ xs: 2, md: 6 }}
        disableEqualOverflow
      >
        <Grid xs={12} flexGrow={1} sx={{ minHeight: 0 }}>
          <Grid
            container
            columns={12}
            rowSpacing={{ xs: 3, md: 0 }}
            columnSpacing={{ xs: 0, md: 2 }}
            sx={{ height: "100%" }}
          >
            <Grid
              md={6}
              xs={12}
              sx={{
                position: "relative",
                zIndex: 2,
                height: "100%",
                minHeight: "100%",
              }}
            >
              <BisListingMapped
                selectedMedia={selectedMedia}
                refreshKey={refreshKey}
                onRefreshNotMapped={handleRefreshBothSides}
              />
            </Grid>

            <Grid
              md={6}
              xs={12}
              sx={{
                position: "relative",
                zIndex: 1,
                height: "100%",
                minHeight: "100%",
              }}
            >
              <BisListingNotMapped
                selectedMedia={selectedMedia}
                refreshKey={refreshKey}
                onRefreshMapped={handleRefreshBothSides}
              />
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

AllmappingsCreation.propTypes = {
  selectedMedia: PropTypes.object,
};

export default AllmappingsCreation;
